import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = ["map"]

  connect() {
    this.loadSVG();
  }

  disconnect() {
    this.removeEventListeners();
  }

  loadSVG() {
    fetch('/map-full.svg')
      .then((res) => {
        if (!res.ok) throw new Error('Network response was not ok');
        return res.text();
      })
      .then((svg) => {
        this.mapTarget.innerHTML = svg;
        this.addEventListeners();
      })
      .catch((error) => console.error('Error loading SVG:', error));
  }

  addEventListeners() {
    this.mapTarget.addEventListener('mouseover', this.handleMouseOver);
    this.mapTarget.addEventListener('mouseout', this.handleMouseLeave);
    this.mapTarget.addEventListener('click', this.handleClick);
    this.mapTarget.querySelectorAll('.prefecture').forEach(pref => {
      pref.addEventListener('click', this.handleClick);
    });



  }

  removeEventListeners() {
    this.mapTarget.removeEventListener('mouseover', this.handleMouseOver);
    this.mapTarget.removeEventListener('mouseout', this.handleMouseLeave);
    this.mapTarget.removeEventListener('click', this.handleClick);
  }

  handleMouseOver = (event) => {
    event.target.style.fill = '#3B82F6';
  }

  handleMouseLeave = (event) => {
    event.target.style.fill = '';
  }

  handleClick = (event) => {
    const code = event.currentTarget.dataset.code;
    if (code) {
      location.href = `/prefectures/${code}`;
    }
  }
}
